import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-initiatebankstatementanalysis',
  templateUrl: './initiatebankstatementanalysis.component.html',
  styleUrls: ['./initiatebankstatementanalysis.component.css']
})
export class InitiatebankstatementanalysisComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
